var scope_0 = require('/opt/build/repo/packages/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_1 = require('/opt/build/repo/packages/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f6206b38dd25ba14af8f77169fd4f87a.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    